import React from "react";
import OwnersList from "./DuplicateOwners/OwnersList";
import OwnershipQuestionnarieForm from "./OwnershipForm/OwnershipQuestionnarieForm";
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd';
import { AxiosError, AxiosResponse } from "axios";
import { OwnersForAdditionalInformation, OwnershipInformationdata } from "./OwnershipForm/Ownershipinfomationdata";
import OwnershipInformationMainCC from "./OwnershipInformation/OwnershipInformationMainCC";
import { cloneDeep } from "lodash";
import Service from "../../../services";
import { BankUserContext } from "../../../bankUserContext";
import { catchError } from "../../../utils/Utils";
import FinSpinner from "../../../commonfields/FinSpinner";



interface OwnershipQuestionnarieProps {
  currentQuestions?: any;
  clientProductId?: any;
  disableFields?: boolean;

}

interface OwnershipQuestionnarieState {

  questionsCompleted: boolean,
  currentQuestions: any[],
  formInitialvalues: any,
  OwnersInformation: any[],

  individualsData: OwnershipInformationdata[];
  loader: boolean;
  clientStockData: any;
  entityType: any;
  OwnershipInformationdata: any;
  newRowValues: any;
}


class OwnershipQuestionnaireComponent extends React.Component<
  OwnershipQuestionnarieProps,
  OwnershipQuestionnarieState
> {
  OwnersInformation: any;
  service = new Service();
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  constructor(props: OwnershipQuestionnarieProps) {
    super(props);
    this.state = {
      questionsCompleted: false,
      currentQuestions: [],
      formInitialvalues: {},
      entityType: {},
      OwnersInformation: [{
        identities: [{ name: "John Kowalski", value: 1234, isPrimary: true },
        { name: "John Kowalski", value: 1234, isPrimary: false },
        { name: "John Kowalski", value: 1234, isPrimary: false }],
        OwnershipPercentage: "24%",
        isCompeleted: true,

      },
      {
        identities: [{ name: "John Kowalski", value: 1234, isPrimary: true }],
        OwnershipPercentage: "24%",
        isCompeleted: false
      }],
      individualsData: [],
      loader: false,
      clientStockData: "no",
      OwnershipInformationdata: {},
      newRowValues: {}
    };
  }


  getIndividuals = () => {
    const clientProductId = this.props?.clientProductId;

    this.service
      .getOwnersOfTypeIndividuals(clientProductId)
      .then((res: AxiosResponse<OwnershipInformationdata[]>) => {
        this.setState({ individualsData: res.data });
      })
      .catch((error: AxiosError) => {
        console.log(error)
      })
  }



  getStockSymbol = () => {
    const clientProductId = this.props?.clientProductId;
    this.setState({ loader: true })
    this.service
      .getStockSymbol(clientProductId)
      .then((response: any) => {
        this.setState({ loader: false })
        this.setState({ clientStockData: response?.data })
        this.getAllOwnershipContacts();
      })

      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  postSaveStockSymbol = (yesOrNo?: string) => {
    const clientProductsId = this.props?.clientProductId
    const postData = { ...this.state.clientStockData, duplicateIndividuals: yesOrNo, clientProductsId: clientProductsId }
    this.service.postSaveStockSymbol(postData).then(() => {
      this.getStockSymbol();
    })
  }

  getAllOwnershipContacts = () => {
    const clientProductId = this.props?.clientProductId;
    this.setState({ loader: true })
    this.service
      .getOwnersForAdditionalInformation(clientProductId)
      .then((response: any) => {
        const owners = response?.data || [];
        this.setState({ OwnersInformation: owners, loader: false })
        //this.getStockSymbol();
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        this.setState({ loader: false })
      });
  };
  getWelcomeQuestion = () => {
    const clientProductId = this.props?.clientProductId;
    clientProductId && this.service.getFirstQuestion(clientProductId).then((response: any) => {
      if (response.data) {
        const answer = response.data?.answers[0]?.optionId;


        const entityType = response.data.options.find(
          (m: any) => m.value === answer
        );


        this.setState({

          entityType
        });

      }
    });
  };


  componentDidMount() {
    this.getIndividuals();
    this.getAllOwnershipContacts();
    this.getStockSymbol();
    this.getWelcomeQuestion();
  }

  updateNewRowValues(key: string, val: any, id: string) {
    const temp = cloneDeep(this.state.newRowValues);

    if (!temp[id]) {
      temp[id] = {};
    }
    temp[id][key] = val;
    this.setState({
      newRowValues: temp
    })
  }

  updateBulkRowValues(obj: any, id: string) {
    const temp = cloneDeep(this.state.newRowValues);

    if (!temp[id]) {
      temp[id] = {};
    }
    temp[id] = { ...temp[id], ...obj };
    this.setState({
      newRowValues: temp
    })
  }

  resetNewRowValues(id?: string) {
    let temp = cloneDeep(this.state.newRowValues);
    if (id) {
      temp[id] = {};
    } else {
      temp = {};
    }
    this.setState({
      newRowValues: temp
    })
  }


  render() {
    return (
      <>
        {this.state.loader ? (
          <div className="spinnerDiv">
            <FinSpinner />
          </div>
        ) : (
          ""
        )}
        <div className="questionaryWrap">
          <p className="subTitle"> Please complete the following items.
            Your progress will be auto-saved as you complete each item.
            You can stop and come back at any time.</p>
          <div>
            <OwnershipQuestionnarieForm
              getAllOwnershipContacts={this.getAllOwnershipContacts}
              getIndividuals={this.getIndividuals}
              entityType={this.state.entityType}
              getStockSymbol={this.getStockSymbol}
              OwnershipInformationdata={this.state.OwnershipInformationdata}
              newRowValues={this.state.newRowValues}
              updateNewRowValues={this.updateNewRowValues.bind(this)}
              updateBulkRowValues={this.updateBulkRowValues.bind(this)}
              resetNewRowValues={this.resetNewRowValues.bind(this)}
              clientProductsId={this.props.clientProductId}
              disableFields={this.props.disableFields}
              ownersInformation={this.state.OwnersInformation}

            />
          </div>
          {this.state.individualsData.length > 0 && <div>
            <DndProvider backend={HTML5Backend}>
              <OwnersList
                individualsData={this.state.individualsData}
                getIndividuals={this.getIndividuals}
                clientStockData={this.state.clientStockData}
                postSaveStockSymbol={this.postSaveStockSymbol}
                getAllOwnershipContacts={this.getAllOwnershipContacts}
                disableFields={this.props.disableFields}
              />
            </DndProvider>
          </div>}
          <div>
            <OwnershipInformationMainCC
              OwnersInformation={this.state.OwnersInformation}
              getAllOwnershipContacts={this.getAllOwnershipContacts}
              entityType={this.state.entityType}
              clientStockData={this.state.clientStockData}
              clientProductsId={this.props.clientProductId}
              disableFields={this.props.disableFields}
            />
          </div>

        </div>
      </>
    );
  }
}
export default OwnershipQuestionnaireComponent;